import { COUNTRIES } from 'appconstants';

export default value => Object.keys(COUNTRIES)
  .map(country => COUNTRIES[country])
  .find(country => country.id === value).PHONE_CODE;
